let BASEURL = 'https://serversql.cy-zq.cn/api/diyInterface';
import { request } from '@umijs/max';

export async function getExcelByName(params, options) {
  return request(`${BASEURL}/excel/getExcelByName`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
export async function addOrUpdateByExcelName(params, options) {
  return request(`${BASEURL}/excel/addOrUpdateByExcelName`, {
    method: 'POST',
    data: {
      ...params,
    },
    ...(options || {}),
  });
}

//查询结果表
export async function getResult(params, options) {
  return request(`${BASEURL}/excel/result`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

//插入结果
export async function addOrUpdateByExcelText(params, options) {
  return request(`${BASEURL}/excel/addOrUpdateByExcelText`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
//清空报名结果表 /excel/clearResult
export async function clearResult(params, options) {
  return request(`${BASEURL}/excel/clearResult`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

//根据ID删除记录
export async function deleResultById(params, options) {
  return request(`${BASEURL}/excel/deleResultById`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

//根据关键字查询记录
export async function queryResultByText(params, options) {
  return request(`${BASEURL}/excel/queryResultByText`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
//获取密钥列表
export async function getKeyList(params, options) {
  return request(`${BASEURL}/video/getKeyList`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
//根据ID删除密钥
export const deleteKeyById = async (id) => {
  const response = await fetch(`${BASEURL}/video/delKeyById?id=${id}`);
  const data = await response.json();
  return data;
};
//添加密钥
export const addKey = async (keyValue) => {
  const response = await fetch(`${BASEURL}/video/addKey?keyValue=${keyValue}`);
  const data = await response.json();
  return data;
};
